






























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
const dateFormat = require('bmh/date-format');
const uuidv4 = require('uuid/v4');
const getUrl = require('bmh/url-with-param');
const profile = storage.getItem('profile') || {};
const merchant_id = profile.merchant_id || '';
const { VUE_APP_FCREST: FCREST, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  clerk_info: `${FCREST}/promotion/shang/activity/clerk`,
  activity_info: `${FCREST}/promotion/shang/activity/`,
  visitor: `${FCREST}/promotion/shang/statement/visitor`,
  get_setting_info: `${FCAPI}/shang/setting/profile/${merchant_id}`,
};

interface PaginationData {
  current: number;
  data: any[];
  last: number;
  size: number;
  total: number;
}

function getClerkData(remote?: PaginationData) {
  remote = (remote || {}) as PaginationData;
  return {
    current: remote.current || 1,
    data: remote.data || [],
    last: remote.last || 1,
    total: remote.total || 0,
    size: remote.size || 1,
  };
}

function getVisitorData(remote?: PaginationData) {
  remote = (remote || {}) as PaginationData;
  return {
    current: remote.current || 1,
    data: remote.data || [],
    last: remote.last || 1,
    total: remote.total || 0,
    size: remote.size || 1,
  };
}
interface SettingInfo {
  guide_to_wx_id: string;
  guide_to_wx_qrcode: string;
  logo: string;
  mobile: string;
  role_name: string;
  role_name_two: string;
  specify_ware_name: string;
  wxapp_name: string;
}
function getSettingInfo(remote: SettingInfo) {
  remote = remote || {};
  return {
    guide_to_wx_id: remote.guide_to_wx_id || '',
    guide_to_wx_qrcode: remote.guide_to_wx_qrcode || '',
    logo: remote.logo || '',
    mobile: remote.mobile || '',
    role_name: remote.role_name || '合伙人',
    role_name_two: remote.role_name_two || '大使',
    specify_ware_name: remote.specify_ware_name || '',
    wxapp_name: remote.wxapp_name || '',
  };
}
@Component
export default class ActivityConfig extends Vue {
  activity_id: number = 0;
  is_loading: boolean = false;
  activity: any = {};
  now_timestamp: number = 0;
  level: string = '1';
  clerk_list_page: number = 1;
  visitor_list_page: number = 1;
  clerk_data: PaginationData = getClerkData();
  visitor_data: PaginationData = getVisitorData();
  moment: Moment[] = [];
  setting_info: any = {};
  // 监听等级是否切换
  @Watch('level')
  async changeLevel() {
    this.clerk_data = getClerkData();
    await this.getClerkList(this.activity_id, this.clerk_list_page, this.level);
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 选择日期后重新获取浏览人列表
  selectDate() {
    if (this.moment && this.moment.length > 0) {
      this.getVisitorList(
        this.activity_id,
        20,
        this.visitor_list_page,
        +this.moment[0].format('X'),
        +this.moment[1].format('X'),
      );
    } else {
      this.visitor_data = getVisitorData();
      this.getVisitorList(this.activity_id, 20, this.visitor_list_page);
    }
  }

  // 获取分销人列表
  async getClerkList(id: number, page: number, clerk_level: string) {
    this.is_loading = true;
    const _data = await this.$axios.get(
      `${API.clerk_info}?activity_id=${id}&page=${page}&clerk_level=${clerk_level}`,
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.clerk_data = _data.data.data.clerk_list;
    const sum_data = _data.data.data.clerk_sum;
    if (this.clerk_data.data.length > 0) {
      this.clerk_data.data.push({
        id: uuidv4(),
        clerk_name: '合计',
        today_page_view: sum_data.today_page_view_sum,
        yesterday_page_view: sum_data.yesterday_page_view_sum,
        page_view: sum_data.page_view_sum,
      });
    }
  }

  // 导出浏览人列表
  exportVisitorList() {
    window.location.href = `${API.visitor}/${this.activity_id}`;
  }

  // 导出分销人数据
  exportClerkData() {
    if (this.clerk_data.data.length > 0) {
      window.location.href = getUrl(API.clerk_info, {
        activity_id: this.activity_id,
        clerk_level: this.level,
        page: this.clerk_list_page,
        is_download: 1,
        type: 'visitor',
      });
    } else {
      this.$message.error('没有找到数据');
    }
  }

  // 获取活动信息
  async getActivityInfo() {
    this.is_loading = true;
    const _data = await this.$axios.get(
      `${API.activity_info}${this.activity_id}`,
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.activity = _data.data.data;
    this.now_timestamp = ~~(+new Date() / 1000);
    if (this.now_timestamp < this.activity.start_time) {
      this.activity.activity_status = '未开始';
    } else {
      if (this.now_timestamp < this.activity.end_time) {
        this.activity.activity_status = '进行中';
      } else {
        this.activity.activity_status = '已结束';
      }
    }
  }

  // 获取浏览人列表
  async getVisitorList(
    id: number,
    page_size: number,
    page: number,
    start_time?: number,
    end_time?: number,
  ) {
    this.is_loading = true;
    const _data = await this.$axios.get(
      `${API.visitor}?activity_id=${id}&page=${page}&start_time=${start_time}&end_time=${end_time}&page_size=${page_size}`,
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.visitor_data = _data.data.data;
  }

  // 分页器
  paginationOption(data: PaginationData) {
    return {
      total: data.total + 1 || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size + 1 || 1,
      current: data.current || 1,
    };
  }

  handChangePagingFirst(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getClerkList(this.activity_id, next_page, '1');
  }
  handChangePagingSecond(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getClerkList(this.activity_id, next_page, '2');
  }
  handChangePagingThird(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getVisitorList(this.activity_id, 20, next_page);
  }
  async created() {
    if (this.$route.query.activity_id) {
      this.activity_id = +this.$route.query.activity_id;
    }
    await this.getActivityInfo();
    await this.getClerkList(this.activity_id, this.clerk_list_page, this.level);
    await this.getVisitorList(this.activity_id, 20, this.visitor_list_page);
    const res = await this.$axios.get(API.get_setting_info);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.setting_info = getSettingInfo(res.data.data);
  }
}
